import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth.jsx'
import { supabase } from '../../lib/supabase.js'
import { loadAlertReference } from '../../lib/assetMedia.js'
import { canonicalizeWorkspaceRouteValue } from '../../lib/positionWorkspaceRoute.js'
import FloatingWindow from '../FloatingWindow.jsx'
import { MediaGallery } from '../MediaAttachments.jsx'

export default function AlertReference({ notification, onClose }) {
  const owner = useAuth()?.user?.id
  const [attachments, setAttachments] = useState([]), [error, setError] = useState(''), [loading, setLoading] = useState(true)
  useEffect(() => {
    let active = true
    setAttachments([]); setError(''); setLoading(true)
    loadAlertReference(supabase, owner, notification.alertId, notification.alertRevision).then(items => { if (active) { setAttachments(items); setLoading(false) } }).catch(() => { if (active) { setError('Alert images could not be loaded. Reopen this reference to retry.'); setLoading(false) } })
    return () => { active = false }
  }, [owner, notification.id, notification.alertId, notification.alertRevision])
  return <FloatingWindow title="Alert reference" onClose={onClose} width={480}>
    <div className="space-y-3 p-4">
      <Link className="font-semibold underline underline-offset-2" to={canonicalizeWorkspaceRouteValue(notification.workspaceRoute, notification.symbol)}>{notification.symbol}</Link>
      <h3 className="font-semibold text-sm">{notification.title}</h3>
      <p className="whitespace-pre-wrap break-words text-xs">{notification.message}</p>
      <p className="text-xs text-inkMuted">Fired {new Date(notification.firedAt || notification.createdAt).toLocaleString()}</p>
      <dl className="grid grid-cols-2 gap-2 text-xs">{(notification.details || []).map((item, index) => <div key={index}><dt className="text-inkMuted">{item.label}</dt><dd>{item.value}</dd></div>)}</dl>
      {loading ? <p role="status" className="text-xs text-inkMuted">Loading reference…</p> : error ? <p role="alert" className="text-xs text-red-500">{error}</p> : attachments.length ? <MediaGallery attachments={attachments}/> : <p className="text-xs text-inkMuted">No images attached to this alert revision.</p>}
    </div>
  </FloatingWindow>
}
